import React from 'react'
import cn from 'classnames'

import { useWindowSize } from '@hooks/useWindowSize'
import { Button } from '@components/Buttons'
import { EndChapter } from '@components/EndChapter'
import { useTheme } from '@hooks/contexts/ThemeContext/ThemeContext'
import { ArrowLeftIcon } from '@components/icons/ArrowLeftIcon'
import { ArrowRightIcon } from '@components/icons/ArrowRightIcon'
import { HorizontalStyleProps } from './interface'

export function HorizontalStyle({
  chapterPages,
  totalPage,
  page,
  nextPage,
  prevPage,
  isShowMobileNavigation,
}: HorizontalStyleProps) {
  const { isLightOrSepiaTheme, isDarkTheme } = useTheme()
  const { isDesktop } = useWindowSize()

  return (
    <>
      <div
        className={cn(
          'relative grid gap-y-[20px] m-auto tablet-mobile:gap-y-[10px]',
          { 'dark-mode': isDarkTheme }
        )}
      >
        <div className='tablet-mobile:flex tablet-mobile:items-center tablet-mobile:justify-between'>
          <div
            className={cn(
              'text-[12px] font-light dark:text-white tablet:text-[16px] desktop:hidden',
              {
                'text-secondary-1': isLightOrSepiaTheme,
                'text-gray-16': isDarkTheme,
              }
            )}
          >
            จำนวน :{' '}
            <span
              className={cn('font-medium dark:text-white', {
                'text-secondary': isLightOrSepiaTheme,
                'text-gray-16': isDarkTheme,
              })}
            >
              {totalPage.toLocaleString()}{' '}
            </span>
            หน้า
          </div>
          <div
            className={cn('dark:text-white desktop:text-center', {
              'text-secondary': isLightOrSepiaTheme,
              'text-gray-16': isDarkTheme,
            })}
          >
            <span className='text-[24px] font-bold mobile:text-[14px] tablet:text-[18px]'>
              {page.toLocaleString()}
            </span>
            <span className='text-[18px] font-light mobile:text-[12px] tablet:text-[16px]'>
              {` / ${totalPage.toLocaleString()}`}
            </span>
          </div>
        </div>
        <div
          className={cn('sticky top-[50%] transition-all duration-500', {
            'opacity-0': !isShowMobileNavigation && !isDesktop,
          })}
        >
          <div className='tablet-mobile:flex tablet-mobile:justify-between'>
            <Button
              className={cn(
                'desktop:absolute desktop:left-0 desktop:top-[50%] h-[40px] border bg-transparent dark:border-dark-10 dark:text-dark-10 tablet-mobile:w-[40px] tablet-mobile:h-[40px]',
                {
                  'text-secondary-1 border border-secondary-1':
                    isLightOrSepiaTheme,
                  '!border-gray-16 !text-gray-16': isDarkTheme,
                }
              )}
              type='button'
              disabled={page === 1}
              onClick={prevPage}
            >
              <ArrowLeftIcon width='24' height='24' />
            </Button>
            <Button
              className={cn(
                'desktop:absolute desktop:right-0 desktop:top-[50%] text-[14px] h-[40px] tablet-mobile:h-[40px]',
                {
                  'tablet-mobile:w-[40px]': page !== totalPage,
                  'bg-primary dark:bg-purple text-white dark:text-white-2':
                    !isDarkTheme,
                  'bg-dark-4 text-gray-16': isDarkTheme,
                }
              )}
              type='button'
              disabled={page === totalPage}
              onClick={nextPage}
            >
              {page === totalPage ? (
                'จบตอน'
              ) : (
                <ArrowRightIcon width='24' height='24' />
              )}
            </Button>
          </div>
        </div>
        <div className='w-[700px] h-full m-auto mobile:w-screen mobile:mx-[calc(calc(-100vw+100%)/2)]'>
          <img
            src={chapterPages[page - 1].imgPath}
            alt='Manga'
            width='100%'
            height='100%'
          />
        </div>
      </div>
      {page === totalPage && <EndChapter />}
    </>
  )
}
